import { ReactElement } from "react";
import { Box, Text, Truncate } from "@twilio-paste/core";
import {
  DisplayPill,
  DisplayPillGroup,
} from "@twilio-paste/core/display-pill-group";
import {
  FormPill,
  FormPillGroup,
  useFormPillState,
} from "@twilio-paste/core/form-pill-group";

import { types } from "./definitions";

const CompositePillGroup = ({
  emptyStateText,
  id,
  label,
  onRemovePill,
  pills,
  viewType = types.CompositePillGroupViewType.display,
}: types.CompositePillGroupProps): ReactElement => {
  const pillState = useFormPillState();

  const renderFormPill = (pillValue: string): ReactElement => (
    <Box maxWidth="size20">
      <Truncate title={pillValue}>{pillValue}</Truncate>
    </Box>
  );

  if (viewType === types.CompositePillGroupViewType.display) {
    return (
      <DisplayPillGroup aria-label={label} id={id}>
        {pills.length ? (
          pills.map((pill) => (
            <DisplayPill key={pill}>{renderFormPill(pill)}</DisplayPill>
          ))
        ) : (
          <Text as="p">{emptyStateText}</Text>
        )}
      </DisplayPillGroup>
    );
  }

  return (
    <form>
      <FormPillGroup {...pillState} aria-label={label}>
        {pills.map((pill) => (
          <FormPill
            key={pill}
            onDismiss={(): void => onRemovePill(pill)}
            {...pillState}
          >
            {renderFormPill(pill)}
          </FormPill>
        ))}
      </FormPillGroup>
    </form>
  );
};

export default CompositePillGroup;
